import { gsap } from "gsap";
import { ScrollTrigger} from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const parallaxBloc = () => {

//---------------------------//
// ===== EFFET parallax sur les blocs   ====
//---------------------------//


    const delSections = gsap.utils.toArray('.parallax');


    if (delSections) {
      delSections.forEach(section => {
        section.content = section.querySelector(".parallax__content");
        section.wrapperImg = section.querySelector(".parallax__wrapperImg");
        section.image = section.querySelector(".parallax__img");
  
      
        let deplacement = 40;
        gsap.set(section.wrapperImg, { height: section.image.offsetHeight - (deplacement * 2) + "px", position: 'relative', overflowY: 'hidden' });
        gsap.set(section.image, { top: "50%", left: '50%', xPercent: -50, yPercent: -50, position: "relative" });
  
        window.addEventListener('resize', () => {
            gsap.set(section.wrapperImg, { height: section.image.offsetHeight - (deplacement * 2) + "px", position: 'relative', overflowY: 'hidden' }); 
        });

        //ScrollTrigger.saveStyles(section.wrapperImg, section.image);
        // ScrollTrigger.refresh();
    
        ScrollTrigger.matchMedia({
          // desktop
          "(min-width: 768px)": function () {
            gsap.from(section.image, {
              y: -deplacement + 'px',
              scrollTrigger: {
                trigger: section.wrapperImg,
                scrub: 1.5,
                invalidateOnRefresh: false,  // This flushes out any internally-recorded starting values.
                // markers : true
              }
            });
          },
          // tablet, mobile
          "(max-width: 767px)": function () {  
            gsap.from(section.image, {
              y: -deplacement + 'px',
              scrollTrigger: {
                trigger: section.wrapperImg,
                scrub: true,
                invalidateOnRefresh: false,
                // markers : false
              }
            });
          },
        })
      });
    }


}

export default parallaxBloc;
